import { types, flow } from 'mobx-state-tree';
import API from '../../api/parking';
import requsetErrorMessage from '../../helpers/requsetErrorMessage';

const Count = types.model('ParkingCount', {
    parking_field_id: types.number,
    capacity: types.optional(types.number, 0),
    issued: types.number,
    assigned: types.optional(types.number, 0),
    activated: types.number,
    not_activated: types.optional(types.number, 0),
    available: types.optional(types.number, 0),
    used: types.number,
});

const ShowRateRow = types.model('ParkingShowRateRow', {
    parking_pass_id: types.identifierNumber,
    parking_field: types.maybeNull(types.string),
    user: types.maybeNull(types.frozen()),
    type: types.maybeNull(types.string),
    season_title: types.maybeNull(types.string),
    game_id: types.maybeNull(types.number),
    games_total: types.number,
    games_used: types.number,
    showrate: types.maybeNull(types.number),
});

const ParkingStats = types
    .model('ParkingStats', {
        counts: types.array(Count),
        showRateRows: types.array(ShowRateRow),
        error: types.union(
            types.optional(types.string, ''),
            types.optional(types.array(types.string), []),
        ),
        dataLoaded: types.optional(types.boolean, false),
    })
    .actions((self) => ({
        getCounts: flow(function* getCounts(parkingFieldId, seasonId) {
            self.error = '';
            try {
                const params = {};
                if (parkingFieldId) params.parking_field_id = parkingFieldId;
                if (seasonId) params.season_id = seasonId;
                const res = yield API.getCounts({ params });
                self.counts = res.data;
                self.dataLoaded = true;
            } catch (error) {
                self.dataLoaded = true;
                self.error = requsetErrorMessage(error && error.message ? error.message : error);
            }
        }),
        getShowRate: flow(function* getShowRate(parkingFieldId, seasonId) {
            self.error = '';
            try {
                const params = {};
                if (parkingFieldId) params.parking_field_id = parkingFieldId;
                if (seasonId) params.season_id = seasonId;
                const res = yield API.getShowRate({ params });
                self.showRateRows = res.data;
                self.dataLoaded = true;
            } catch (error) {
                self.dataLoaded = true;
                self.error = requsetErrorMessage(error && error.message ? error.message : error);
            }
        }),
        setDataLoaded() {
            self.dataLoaded = true;
        },
    }));

export default ParkingStats;
